import React from 'react';
import PropTypes from 'prop-types';

import { Action as StyledAction } from './styles';

const Action = ({ children, className, ...otherProps }) => {
    const classNames = ['item-action', className].join(' ').trim();

    return (
        <StyledAction className={classNames} {...otherProps}>
            {children}
        </StyledAction>
    );
};

Action.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

export default Action;